import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/analytics/VisitorTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/auth/NextAuthToFirebaseSync.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/chat/SupportChatbot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BottomNavigation"] */ "/vercel/path0/components/layout/BottomNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConditionalFooter"] */ "/vercel/path0/components/layout/ConditionalFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/providers/NextAuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/components/providers/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toast"] */ "/vercel/path0/components/ui/Toast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
